export default "https://cdn-static.gokick.com/assets/a6d011c942efc1c6cd2854aca00adc3db9e08265/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";